// import "../index.css";
// import Footer from "../components/Footer";
// //import { useAuth } from "../auth/context";
// import { PageNav } from "../components/PageNav";

// export default function Login() {
//   //   const { user, loading } = useAuth();

//   return (
//     <div>
//       <PageNav />
//       <div className="main_div">
//         <p>LOGIN</p>
//         <div className="show-desktop">
//           <p>DESKTOP</p>
//         </div>
//         <div className="show-mobile">
//           <p>MOBILE</p>
//         </div>
//       </div>
//       <Footer />
//     </div>
//   );
// }

import React, { useState } from "react";
// import { useAuth } from "../AuthContext";
// import HeaderSection, { screenList } from "../components/HeaderSection";
// import { getUserProfileSettings } from "../apiCalls/UserProfile";
import "./Login.css"; // We'll need to create this CSS file
import { PageNav } from "../components/PageNav";
import Footer from "../components/Footer";
import buttonBackground from "../assets/button_background_blue.webp";
import { useAuth } from "../auth/context";
import { useNavigate } from "react-router-dom";
import {
  //cacheProfileSetting,
  getUserProfileSettings,
  // getUserProfileSettings,
} from "../auth/UserProfile";
import { sendPasswordResetEmail } from "firebase/auth";
import { auth } from "../auth/firebase";
//import ApiCall from "../auth/ApiCall";
// Using the web-push library
const Login = () => {
  const [email, setEmail] = useState("");
  const [password, setPassword] = useState("");
  const [error, setError] = useState<string>("");
  const [successMessage, setSuccessMessage] = useState<string>("");
  const [isLoading, setIsLoading] = useState<boolean>(false);
  const { login, loginWithGoogle, loginWithApple } = useAuth();
  const navigate = useNavigate();

  // const [loggedIn, setLoggedIn] = useState(false);

  // // Simple destructuring - no logging that causes re-renders
  // const authContext = useAuth();
  // const { user } = useAuth();

  // const {
  //   signIn,
  //   signUp,
  //   signInWithGoogle,
  //   signInWithApple,
  //   loading: authLoading,
  // } = authContext;

  // const handleEmailLogin = async () => {};
  const handleForgotPassword = async () => {
    if (!email.trim()) {
      setError("Please enter your email address to reset your password");
      return;
    }

    setIsLoading(true);
    setError("");
    setSuccessMessage("");

    try {
      const actionCodeSettings = {
        url: `${window.location.origin}/reset-password`,
        handleCodeInApp: true,
      };
      await sendPasswordResetEmail(auth, email.trim(), actionCodeSettings);
      setSuccessMessage("Password reset email sent! Please check your inbox.");
    } catch (err) {
      if (err instanceof Error) {
        const authError = err as { code?: string; message: string };
        if (authError.code === "auth/user-not-found") {
          setError("No account found with this email address");
        } else if (authError.code === "auth/invalid-email") {
          setError("Invalid email address");
        } else {
          setError("Failed to send password reset email. Please try again.");
        }
      } else {
        setError("Failed to send password reset email. Please try again.");
      }
    } finally {
      setIsLoading(false);
    }
  };
  // const handleGoogleLogin = async () => {};
  const handleRegisterRedirect = async () => {
    navigate("/register");
  };

  // const handleEmailLogin = async () => {
  //   if (!email.trim() || !password.trim()) {
  //     alert("Please enter both email and password");
  //     return;
  //   }

  //   setLoading(true);

  //   try {
  //     const result = await signIn(email.trim(), password);
  //     setLoading(false);

  //     if (result.success) {
  //       setLoggedIn(true);
  //       getUserProfileSettings(result, "email");
  //     } else {
  //       alert(`Login Failed: ${result.error || "An error occurred"}`);
  //     }
  //   } catch (error) {
  //     setLoading(false);
  //     alert("Error: Login failed");
  //   }
  // };

  // const handleGoogleLogin = async () => {
  //   setLoading(true);
  //   const result = await signInWithGoogle();
  //   setLoading(false);

  //   if (result.success) {
  //     setLoggedIn(true);
  //     getUserProfileSettings(result, "google");
  //   } else {
  //     alert(`Google Login Failed: ${result.error || "An error occurred"}`);
  //   }
  // };

  // const handleAppleLogin = async () => {
  //   setLoading(true);
  //   const result = await signInWithApple();
  //   setLoading(false);

  //   if (result.success) {
  //     getUserProfileSettings(result, "apple");
  //   } else {
  //     alert(`Apple Login Failed: ${result.error || "An error occurred"}`);
  //   }
  // };

  // const handleRegisterRedirect = () => {
  //   // Replace with your routing solution (React Router, Next.js router, etc.)
  //   window.location.href = "/register";
  //   // Or with React Router: navigate('/register');
  // };

  // const handleForgotPassword = () => {
  //   // Implement forgot password functionality
  // };

  // if (authLoading) {
  //   return (
  //     <div className="loading-container">
  //       <div className="loading-text">Loading authentication...</div>
  //     </div>
  //   );
  // }

  const handleSubmit = async (
    e: React.FormEvent<HTMLButtonElement>,
  ): Promise<void> => {
    e.preventDefault();
    setError("");
    setIsLoading(true);

    try {
      const user = await login(email, password);
      // Check if email is verified before allowing access
      if (!user.emailVerified) {
        navigate("/verify-email");
        return;
      }

      // navigate("/games");
      //      await getUserProfileSettings();
      await getUserProfileSettings(user, "email", "", navigate);
      // loggedInNavigation();
    } catch (err) {
      if (err instanceof Error) {
        setError(err.message);
      } else {
        setError("An unexpected error occurred");
      }
    } finally {
      setIsLoading(false);
    }
  };

  const handleGoogleLogin = async (): Promise<void> => {
    setError("");
    setIsLoading(true);

    try {
      const user = await loginWithGoogle();
      // navigate("/games");
      await getUserProfileSettings(user, "google", "", navigate);
      //loggedInNavigation();
    } catch (err) {
      //      console.error("Google login handler error:", err);
      if (err instanceof Error) {
        setError(err.message);
      } else {
        setError("Google authentication failed");
      }
    } finally {
      setIsLoading(false);
    }
  };

  const handleAppleLogin = async (): Promise<void> => {
    setError("");
    setIsLoading(true);

    try {
      const user = await loginWithApple();
      await getUserProfileSettings(user, "apple", "", navigate);
    } catch (err) {
      //      console.error("Apple login handler error:", err);
      if (err instanceof Error) {
        setError(err.message);
      } else {
        setError("Apple authentication failed");
      }
    } finally {
      setIsLoading(false);
    }
  };

  return (
    <div>
      {isLoading && (
        <div className="loading-overlay">
          <div className="loading-overlay-spinner"></div>
        </div>
      )}
      <PageNav />
      <div className="form-container" style={{ marginTop: 100 }}>
        <div className="form-content">
          <div className="center_me">
            <h2
              className="font_family_base header_text"
              style={{
                fontSize: 28,
                fontWeight: "bold",
                margin: 0,
              }}
            >
              Login
            </h2>
          </div>
          <div
            style={{
              minHeight: "48px",
              marginTop: "10px",
              marginBottom: "10px",
            }}
          >
            {error && (
              <div
                className="font_family_base error_text_color"
                style={{
                  // backgroundColor: "#fee",
                  // color: "#c33",
                  padding: "15px",
                  borderRadius: "8px",
                  textAlign: "center",
                  border: "1px solid #FF0000",
                }}
              >
                {error}
              </div>
            )}
            {successMessage && (
              <div
                className="font_family_base"
                style={{
                  padding: "15px",
                  borderRadius: "8px",
                  textAlign: "center",
                  border: "1px solid #4CAF50",
                  color: "#4CAF50",
                  backgroundColor: "rgba(76, 175, 80, 0.1)",
                }}
              >
                ✓ {successMessage}
              </div>
            )}
          </div>

          <label className="font_family_base field-name field_name_color">
            Email: *
          </label>
          <input
            className="font_family_base input"
            style={{ marginBottom: 20 }}
            type="email"
            placeholder="Email"
            value={email}
            onChange={(e) => setEmail(e.target.value)}
            autoComplete="email"
            disabled={isLoading}
          />

          <label className="font_family_base field-name field_name_color">
            Password: *
          </label>
          <input
            className="input font_family_base"
            style={{ marginBottom: 20 }}
            type="password"
            placeholder="Password"
            value={password}
            onChange={(e) => setPassword(e.target.value)}
            autoComplete="password"
            disabled={isLoading}
          />

          <button
            className="font_family_base link-text forgot-password"
            onClick={handleForgotPassword}
            type="button"
          >
            Forgot Password
          </button>

          <div
            style={{ display: "flex", justifyContent: "center", width: "100%" }}
          >
            <button
              className="my-form-button-wide button-base button-3d font_family_base"
              onClick={handleSubmit}
              disabled={isLoading}
              style={{
                marginTop: "5px",
                marginBottom: "15px",
                backgroundImage: `url(${buttonBackground})`,
                backgroundSize: "cover",
                backgroundPosition: "center",
                color: "white",
                fontWeight: 700,
              }}
            >
              {isLoading ? (
                <div className="font_family_base loading-spinner"></div>
              ) : (
                "Login with Email"
              )}
            </button>
          </div>

          <button
            className="google-button font_family_base"
            onClick={handleGoogleLogin}
            disabled={isLoading}
          >
            <span className="google-logo-badge">
              <svg
                width="16"
                height="16"
                viewBox="0 0 18 18"
                xmlns="http://www.w3.org/2000/svg"
              >
                <path
                  fill="#4285F4"
                  d="M17.64 9.2c0-.637-.057-1.251-.164-1.84H9v3.481h4.844c-.209 1.125-.843 2.078-1.796 2.717v2.258h2.908c1.702-1.567 2.684-3.875 2.684-6.615z"
                />
                <path
                  fill="#34A853"
                  d="M9 18c2.43 0 4.467-.806 5.956-2.184l-2.908-2.258c-.806.54-1.837.86-3.048.86-2.344 0-4.328-1.584-5.036-3.711H.957v2.332C2.438 15.983 5.482 18 9 18z"
                />
                <path
                  fill="#FBBC05"
                  d="M3.964 10.707c-.18-.54-.282-1.117-.282-1.707s.102-1.167.282-1.707V4.961H.957C.347 6.173 0 7.548 0 9s.348 2.827.957 4.039l3.007-2.332z"
                />
                <path
                  fill="#EA4335"
                  d="M9 3.58c1.321 0 2.508.454 3.44 1.345l2.582-2.58C13.463.891 11.426 0 9 0 5.482 0 2.438 2.017.957 4.961L3.964 7.293C4.672 5.166 6.656 3.58 9 3.58z"
                />
              </svg>
            </span>
            Sign in with Google
          </button>

          <button
            className="apple-button font_family_base"
            onClick={handleAppleLogin}
            disabled={isLoading}
          >
            <svg
              width="16"
              height="19"
              viewBox="0 0 17 20"
              xmlns="http://www.w3.org/2000/svg"
              fill="white"
            >
              <path d="M14.769 10.679c-.022-2.219 1.814-3.291 1.896-3.344-1.033-1.511-2.641-1.718-3.211-1.738-1.368-.138-2.677.807-3.37.807-.694 0-1.762-.787-2.9-.765-1.486.022-2.86.864-3.626 2.19C2.003 10.587 3.15 14.94 4.663 17.31c.748 1.073 1.636 2.276 2.797 2.233 1.127-.045 1.551-.724 2.913-.724 1.362 0 1.74.724 2.927.701 1.21-.022 1.974-1.094 2.715-2.171.857-1.241 1.209-2.449 1.23-2.511-.027-.012-2.354-.904-2.376-3.159zM12.53 3.6C13.14 2.854 13.55 1.823 13.436.77c-.883.036-1.95.588-2.583 1.334-.567.655-1.063 1.706-.929 2.712.985.076 1.99-.501 2.606-1.216z" />
            </svg>
            Sign in with Apple
          </button>

          <button
            className={`font_family_base link-text ${
              isLoading ? "link-text-disabled" : ""
            }`}
            onClick={handleRegisterRedirect}
            disabled={isLoading}
            type="button"
          >
            Don't have an account? Register
          </button>
        </div>
      </div>
      <Footer />
    </div>
  );
};

export default Login;
